import {
  GET_PLANS,
  CREATE_PLAN,
  GET_SUBSCRIPTIONS,
  GET_SUBSCRIPTION,
  CREATE_SUBSCRIPTION,
  UPDATE_SUBSCRIPTION,
  UPDATE_PLAN,
  GET_SUBSCRIPTIONS_REQUEST_PENDING,
  GET_SUBSCRIPTIONS_REQUEST_SUCCESS,
  GET_SUBSCRIPTIONS_REQUEST_ERROR,
  CHANGE_SUBSCRIPTIONS_REQUEST_PENDING,
  CHANGE_SUBSCRIPTIONS_REQUEST_SUCCESS,
  CHANGE_SUBSCRIPTIONS_REQUEST_ERROR,
  GET_CUSTOMER_SUBSCRIPTIONS,
  GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_PENDING,
  GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_SUCCESS,
  GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_ERROR,
} from '../types/subscriptions'

const initialState = {
  plans: [],
  items: [],
  item: {},
  customerSubscriptions: [],
  customerSubscriptionsTotal: 0,
  isGetLoading: false,
  isChangeLoading: false,
  errors: [],
}

const subscriptions = (state = initialState, action) => {
  switch (action.type) {
    case GET_PLANS:
      return { ...state, plans: action.payload }
    case GET_SUBSCRIPTIONS:
      return { ...state, items: action.payload }
    case GET_SUBSCRIPTION:
      return { ...state, item: action.payload }
    case GET_CUSTOMER_SUBSCRIPTIONS:
      return {
        ...state,
        customerSubscriptions: action.payload?.result || [],
        customerSubscriptionsTotal: action.payload?.total ?? 0,
      }
    case CREATE_PLAN:
    case CREATE_SUBSCRIPTION:
    case UPDATE_SUBSCRIPTION:
    case UPDATE_PLAN:
      return state
    case GET_SUBSCRIPTIONS_REQUEST_PENDING:
    case GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_PENDING:
      return { ...state, isGetLoading: true }
    case GET_SUBSCRIPTIONS_REQUEST_SUCCESS:
    case GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_SUCCESS:
      return { ...state, errors: [], isGetLoading: false }
    case GET_SUBSCRIPTIONS_REQUEST_ERROR:
    case GET_CUSTOMER_SUBSCRIPTIONS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isGetLoading: false }
    case CHANGE_SUBSCRIPTIONS_REQUEST_PENDING:
      return { ...state, isChangeLoading: true }
    case CHANGE_SUBSCRIPTIONS_REQUEST_SUCCESS:
      return { ...state, errors: [], isChangeLoading: false }
    case CHANGE_SUBSCRIPTIONS_REQUEST_ERROR:
      return { ...state, errors: action.payload, isChangeLoading: false }
    default:
      return state
  }
}

export default subscriptions
